// TextArea.js
import React, { useId } from "react";
import styles from "./css/input.module.css";

function Textarea(props) {
  let { parentclasses, name, value, onChange, textareaclasses, rows, cols, id } = props;
  let uniqueId = useId();
  return (
    <div className={parentclasses}>
      <textarea
        className={`form-controlcustom form-control ${styles.input} ${textareaclasses}`}
        id={id || uniqueId}
        textareaclasses={textareaclasses}
        name={name}
        value={value}
        onChange={onChange}
        rows={rows}
        cols={cols}
      />
    </div>
  );
}

export default Textarea;
